/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { SystemVarsPayablesDto } from '@gh/builder-shared-data';

import { map } from 'lodash';

export type SystemVarsPayables = SystemVarsPayablesDto;
export type SystemVarsPayablesFormTrackingCaption = { value: string };
export type SystemVarsPayablesForm = SystemVarsPayables & { trackingCaptions: SystemVarsPayablesFormTrackingCaption[] };

export function systemVarsPayablesToDto(payables: SystemVarsPayables): SystemVarsPayablesForm {
  return {
    ...payables,
    trackingCaptions: map<any, any>(
      payables.trackingCaptions,
      ({ value }: SystemVarsPayablesFormTrackingCaption) => value,
    ),
  };
}

export function systemVarsPayablesFromDto(payables: SystemVarsPayablesForm): SystemVarsPayables {
  return {
    ...payables,
    trackingCaptions: map<any, any>(
      payables.trackingCaptions,
      (trackingCaption: string) => ({ value: trackingCaption }),
    ),
  };
}
